
<v-flex>
    <v-progress-linear
        v-if="overlay && ! (!! user)"
        absolute
        indeterminate
    ></v-progress-linear>

    <card-collection
        :class="{ 'px-0-nested': !! user }"
        :meta="meta"
        :busy="overlay"
        @updated="updated"
    >
        <template #filters>
            <v-toolbar
                elevation="0"
                color="transparent"
                :class="{ 'mt-7 mb-1': ! (!! user) }"
                height="56"
            >
                <v-text-field
                    v-model="queries.search"
                    @click:clear="clear"
                    class="input-search md mr-2"
                    clearable
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    :label="t('general_label_search')"
                ></v-text-field>

                <span class="sub-label px-5">{{ t('general_label_start') }}</span>

                <date-picker-modal
                    :value="queries.start_from"
                    @updated="(v) => queries.start_from = v"
                >
                    <template #default="{ on, attrs }">
                        <div
                            v-on="on"
                            v-bind="attrs"
                        >
                            <v-text-field
                                v-model="queries.start_from"
                                class="xs input-color-inherit"
                                outlined
                                dense
                                hide-details
                                readonly
                                :label="t('general_label_from')"
                            ></v-text-field>
                        </div>
                    </template>
                </date-picker-modal>

                <span class="sub-label px-2">-</span>

                <date-picker-modal
                    :value="queries.start_to"
                    @updated="(v) => queries.start_to = v"
                >
                    <template #default="{ on, attrs }">
                        <div
                            v-on="on"
                            v-bind="attrs"
                        >
                            <v-text-field
                                v-model="queries.start_to"
                                class="xs input-color-inherit"
                                outlined
                                dense
                                hide-details
                                readonly
                                :label="t('general_label_to')"
                            ></v-text-field>
                        </div>
                    </template>
                </date-picker-modal>

                <span class="sub-label px-5">{{ t('general_label_end') }}</span>

                <date-picker-modal
                    :value="queries.end_from"
                    @updated="(v) => queries.end_from = v"
                >
                    <template #default="{ on, attrs }">
                        <div
                            v-on="on"
                            v-bind="attrs"
                        >
                            <v-text-field
                                v-model="queries.end_from"
                                class="xs input-color-inherit"
                                outlined
                                dense
                                hide-details
                                readonly
                                :label="t('general_label_from')"
                            ></v-text-field>
                        </div>
                    </template>
                </date-picker-modal>

                <span class="sub-label px-2">-</span>

                <date-picker-modal
                    :value="queries.end_to"
                    @updated="(v) => queries.end_to = v"
                >
                    <template #default="{ on, attrs }">
                        <div
                            v-on="on"
                            v-bind="attrs"
                        >
                            <v-text-field
                                v-model="queries.end_to"
                                class="xs input-color-inherit"
                                outlined
                                dense
                                hide-details
                                readonly
                                :label="t('general_label_to')"
                            ></v-text-field>
                        </div>
                    </template>
                </date-picker-modal>

                <v-spacer></v-spacer>



                <v-btn
                    @click="search"
                    class="sm mx-5"
                    color="primary"
                >{{ t('general_action_search') }}
                </v-btn>

                <v-btn
                    v-ripple="false"
                    plain
                    color="orange darken-4"
                    @click="reset"
                >{{ t('general_action_reset_filters') }}
                </v-btn>

            </v-toolbar>

            <v-toolbar
                elevation="0"
                color="transparent"
                height="56"
                class="mt-2"
            >
                <v-select
                    v-model="queries.creators"
                    :items="communityExtraCreators()"
                    class="md mr-2"
                    outlined
                    dense
                    append-icon="mdi-chevron-down"
                    hide-details
                    :label="t('general_label_created_by')"
                ></v-select>

                <v-select
                    v-model="queries.status"
                    :items="[ { text: '-', value: '' } ].concat(eventStatuses())"
                    class="md mr-2"
                    outlined
                    dense
                    append-icon="mdi-chevron-down"
                    hide-details
                    :label="t('event_label_status')"
                ></v-select>

                <v-select
                    v-model="queries.event_type"
                    :items="[ { text: '-', value: '' } ].concat(eventTypes())"
                    class="md mr-2"
                    outlined
                    dense
                    append-icon="mdi-chevron-down"
                    hide-details
                    :label="t('event_label_event_type')"
                ></v-select>

                <v-checkbox
                    v-if="! (!! user)"
                    v-model="queries.only_suspended"
                    :label="t('general_label_show_suspended')"
                    hide-details
                    class="ma-0 ml-2 customized-deep-primary-color"
                />
            </v-toolbar>
        </template>

        <template #data>
            <thead>
            <tr>
                <th class="touched">
                    <sort-field
                        v-model="queries.sort"
                        field="id"
                        @touched="onSort"
                    >{{ t('event_label_id') }}</sort-field>
                </th>
                <th class="touched">
                    <sort-field
                        v-model="queries.sort"
                        field="name"
                        @touched="onSort"
                    >{{ t('event_label_name') }}</sort-field>
                </th>
                <th>
                    <sort-field
                        v-model="queries.sort"
                        field="start_at"
                        @touched="onSort"
                    >{{ t('event_label_start_at') }}</sort-field>
                </th>
                <th>{{ t('event_label_end_at') }}</th>
                <th>{{ t('general_label_creation_date') }}</th>
                <th>{{ t('event_label_event_type') }}</th>
                <th>{{ t('general_label_created_by') }}</th>
                <th>{{ t('event_label_attendees') }}</th>
                <th class="text-center">{{ t('general_label_action') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="collection.data.length === 0">
                <td class="text-center" colspan="8">{{ t('general_text_no_data') }}</td>
            </tr>
            <template v-else v-for="event in collection.data">
                <tr>
                    <td>
                        <a
                            :href="`/events/${event.id}/view`"
                            @click.prevent="view(event)"
                            :class="{ 'orange--text': ! event.enabled }"
                        >{{ event.id }}</a>
                    </td>
                    <td>
                        <a
                            :href="`/events/${event.id}/view`"
                            @click.prevent="view(event)"
                        >{{ event.name }}</a>
                    </td>
                    <td>{{ event.schedules.length ? event.schedules[0].startAt.format('DD/MM/YYYY HH:mm') : '-' }}</td>
                    <td>{{ event.schedules.length ? event.schedules.slice(-1)[0].endAt.format('DD/MM/YYYY HH:mm') : '-' }}</td>
                    <td>{{ event.createdAt ? event.createdAt.format('DD/MM/YYYY HH:mm') : '-' }}</td>
                    <td>{{ eventTypeTitle(event.eventType) }}</td>
                    <td>
                        <template v-if="! event.userId">{{ communityExtraCreatorTitle(event.creator) }}</template>
                        <a
                            v-else
                            @click="go({ name: 'trainees.show', params: { id: event.userId }, query: { tab: '6' } })"
                        >#{{ event.user.fullName }}</a>
                    </td>
                    <td>{{ event.participantCount }}</td>
                    <td
                        class="text-center"
                    >
                        <v-menu
                            v-if="! (!! user)"
                            offset-y
                            left
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item
                                    @click.prevent="view(event)"
                                >
                                    <v-list-item-title
                                        class="customized-deep-primary--text"
                                    >{{ t('general_action_details') }}
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    v-if="permitted('admin_event_management')"
                                    @click.prevent="edit(event)"
                                >
                                    <v-list-item-title
                                        class="customized-deep-primary--text"
                                    >{{ t('general_action_edit') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    v-if="permitted('admin_workout_management')"
                                    :to="{ name: 'events.create', query: { id: event.id } }"
                                >
                                    <v-list-item-title
                                        class="customized-deep-primary--text"
                                    >{{ t('general_action_duplicate') }}
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    v-if="permitted('admin_event_management')"
                                    @click.prevent="suspend(event)"
                                >
                                    <v-list-item-title
                                        v-if="event.enabled"
                                        class="customized-deep-primary--text"
                                    >{{ t('general_action_suspend') }}
                                    </v-list-item-title>
                                    <v-list-item-title
                                        v-else
                                        class="orange--text"
                                    >{{ t('general_action_unsuspend') }}
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click.prevent="createDynamicLink(event)">
                                    <v-list-item-title class="customized-deep-primary--text"
                                    >{{ t('general_action_create_dynamic_link') }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <v-btn
                            v-else
                            icon
                            :to="`/events/${event.id}/view`"
                        >
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
            </tbody>
        </template>
    </card-collection>
</v-flex>
